import { Box } from "@mui/joy";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Cargando } from "../utils/Cargando";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";

export const Resultado = () => {
  const { id } = useParams();
  const [load, setLoad] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      cargar(id);
    }
  }, [id]);

  function cargar(id) {
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch("https://portal.publimed.net/api/v1/CCompra/" + id, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);

        if (res?.estado === "APROBADO") {
          localStorage.setItem("carritoPublimed", JSON.stringify([]));
          localStorage.setItem("carritoPro", JSON.stringify([]));

          dispatch({
            type: "CARRO_SUCCESS",
            payload: {
              carro: [],
            },
          });
        }
        setLoad(false);
        Swal.fire({
          icon: res?.estado === "APROBADO" ? "success" : "error",
          html:
            "La compra ha sido: <strong>" +
            (res?.estado === "APROBADO" ? "APROBADA" : "CANCELADA") +
            "</strong>",
          willClose: () => {
            navigate("/");
          },
        });
      })
      .catch((error) => {
        setLoad(false);
        console.error(error);
        Swal.fire({
          icon: "warning",
          html: "La compra no fue realizada",
        });
        navigate("/");
      });
  }
  return (
    <Box>
      <Helmet>
        <title>{"Publimed Store"}</title>
      </Helmet>
      <Cargando open={load} />
    </Box>
  );
};
